module.exports = __webpack_public_path__ + "img/moonbeam.76e7cc48.svg";